import $ from 'jquery';

$(function() {
    $('[data-toggle-button]').on('click', function(e) {
        e.preventDefault();
        var targetId = $(this).data('toggle-target-id');
        $('#' + targetId).slideToggle('fast');

        $(this).find('i').toggleClass('fa-chevron-right');
        $(this).find('i').toggleClass('fa-chevron-down');
    });
});